<template>
  <div class="memo_page" :class="{is_mobile: isMobile}">
    <div class="memo_header">
      <div class="search_box">
        <input class="search_input" type="text" v-model="keyword" placeholder="搜索备忘录..." @keyup.enter="searchMemo">
        <div v-if="keyword" class="clear_btn" @click="clearSearch"><i class="iconfont iconshanchu"></i></div>
      </div>
      <div class="filter_box">
        <select class="filter_select" v-model="filterTag" @change="searchMemo">
          <option value="">全部分类</option>
          <option v-for="(tag, index) in allTags" :key="index" :value="tag">{{tag}}</option>
        </select>
        <select class="filter_select" v-model="filterStatus" @change="searchMemo">
          <option value="">全部状态</option>
          <option value="0">未完成</option>
          <option value="1">已完成</option>
        </select>
      </div>
      <div v-if="userId == 41" class="add_btn" @click="openAdd"><i class="iconfont iconjiashang1"></i> 新增</div>
    </div>
    <div class="quadrant_layout">
      <div class="quadrant q1" :class="{active: activeQuadrant === 1}" @click="filterByQuadrant(1)">
        <div class="q_header">
          <span class="q_title">重要 & 紧急</span>
          <span class="q_count">{{quadrantData[1].length}}</span>
        </div>
        <div class="q_list">
          <div class="memo_item" v-for="item in quadrantData[1]" :key="item.id" :class="{done: item.status === 1}" @click.stop="toggleStatus(item)">
            <div class="memo_check" :class="{checked: item.status === 1}"></div>
            <div class="memo_info" @click.stop="openEdit(item)">
              <div class="memo_title">{{item.title}}</div>
              <div class="memo_meta">
                <span v-if="item.tag" class="memo_tag">{{item.tag}}</span>
                <span v-if="item.priority" class="memo_priority" :class="'p' + item.priority">{{priorityMap[item.priority]}}</span>
                <span v-if="item.deadline" class="memo_deadline" :class="{overdue: isOverdue(item.deadline)}">{{formatDate(item.deadline)}}</span>
              </div>
            </div>
            <div v-if="userId == 41" class="memo_delete" @click.stop="deleteItem(item)"><i class="iconfont iconshanchu"></i></div>
          </div>
          <div v-if="!quadrantData[1].length" class="q_empty">暂无</div>
        </div>
      </div>
      <div class="quadrant q2" :class="{active: activeQuadrant === 2}" @click="filterByQuadrant(2)">
        <div class="q_header">
          <span class="q_title">重要 & 不紧急</span>
          <span class="q_count">{{quadrantData[2].length}}</span>
        </div>
        <div class="q_list">
          <div class="memo_item" v-for="item in quadrantData[2]" :key="item.id" :class="{done: item.status === 1}" @click.stop="toggleStatus(item)">
            <div class="memo_check" :class="{checked: item.status === 1}"></div>
            <div class="memo_info" @click.stop="openEdit(item)">
              <div class="memo_title">{{item.title}}</div>
              <div class="memo_meta">
                <span v-if="item.tag" class="memo_tag">{{item.tag}}</span>
                <span v-if="item.priority" class="memo_priority" :class="'p' + item.priority">{{priorityMap[item.priority]}}</span>
                <span v-if="item.deadline" class="memo_deadline" :class="{overdue: isOverdue(item.deadline)}">{{formatDate(item.deadline)}}</span>
              </div>
            </div>
            <div v-if="userId == 41" class="memo_delete" @click.stop="deleteItem(item)"><i class="iconfont iconshanchu"></i></div>
          </div>
          <div v-if="!quadrantData[2].length" class="q_empty">暂无</div>
        </div>
      </div>
      <div class="quadrant q3" :class="{active: activeQuadrant === 3}" @click="filterByQuadrant(3)">
        <div class="q_header">
          <span class="q_title">不重要 & 紧急</span>
          <span class="q_count">{{quadrantData[3].length}}</span>
        </div>
        <div class="q_list">
          <div class="memo_item" v-for="item in quadrantData[3]" :key="item.id" :class="{done: item.status === 1}" @click.stop="toggleStatus(item)">
            <div class="memo_check" :class="{checked: item.status === 1}"></div>
            <div class="memo_info" @click.stop="openEdit(item)">
              <div class="memo_title">{{item.title}}</div>
              <div class="memo_meta">
                <span v-if="item.tag" class="memo_tag">{{item.tag}}</span>
                <span v-if="item.priority" class="memo_priority" :class="'p' + item.priority">{{priorityMap[item.priority]}}</span>
                <span v-if="item.deadline" class="memo_deadline" :class="{overdue: isOverdue(item.deadline)}">{{formatDate(item.deadline)}}</span>
              </div>
            </div>
            <div v-if="userId == 41" class="memo_delete" @click.stop="deleteItem(item)"><i class="iconfont iconshanchu"></i></div>
          </div>
          <div v-if="!quadrantData[3].length" class="q_empty">暂无</div>
        </div>
      </div>
      <div class="quadrant q4" :class="{active: activeQuadrant === 4}" @click="filterByQuadrant(4)">
        <div class="q_header">
          <span class="q_title">不重要 & 不紧急</span>
          <span class="q_count">{{quadrantData[4].length}}</span>
        </div>
        <div class="q_list">
          <div class="memo_item" v-for="item in quadrantData[4]" :key="item.id" :class="{done: item.status === 1}" @click.stop="toggleStatus(item)">
            <div class="memo_check" :class="{checked: item.status === 1}"></div>
            <div class="memo_info" @click.stop="openEdit(item)">
              <div class="memo_title">{{item.title}}</div>
              <div class="memo_meta">
                <span v-if="item.tag" class="memo_tag">{{item.tag}}</span>
                <span v-if="item.priority" class="memo_priority" :class="'p' + item.priority">{{priorityMap[item.priority]}}</span>
                <span v-if="item.deadline" class="memo_deadline" :class="{overdue: isOverdue(item.deadline)}">{{formatDate(item.deadline)}}</span>
              </div>
            </div>
            <div v-if="userId == 41" class="memo_delete" @click.stop="deleteItem(item)"><i class="iconfont iconshanchu"></i></div>
          </div>
          <div v-if="!quadrantData[4].length" class="q_empty">暂无</div>
        </div>
      </div>
    </div>
    <div class="memo_summary">
      共 <strong>{{memoList.length}}</strong> 项，未完成 <strong>{{memoList.filter(m => m.status === 0).length}}</strong> 项
      <span v-if="activeQuadrant" class="clear_filter" @click="clearQuadrantFilter">清除象限筛选</span>
    </div>
    <template v-if="showOperation">
      <memo-operation :operation.sync="showOperation" :item="editItem" @success="onMemoSuccess" />
    </template>
    <pop ref="memoPop" :title="popMessage" cancel-text="取消" sure-text="确定" :show-sure="showPopSure" @sure="onPopSure" @cancel="closePop" />
  </div>
</template>

<script>
import _ from 'lodash'
import pop from '@/component/pop/pop.vue'
import memoOperation from './component/memoOperation.vue'
import { allMemo, toggleMemoStatus, deleteMemo } from '@/vue_api/memo.js'

export default {
  name: 'memo',
  components: {
    pop,
    memoOperation
  },
  data() {
    return {
      memoList: [],
      keyword: '',
      filterTag: '',
      filterStatus: '',
      activeQuadrant: 0,
      showOperation: 0,
      editItem: {},
      popMessage: '',
      showPopSure: false,
      pendingDelete: null,
      togglingIds: {},
      priorityMap: { 0: '', 1: '低', 2: '中', 3: '高' },
      isMobile: false
    }
  },
  computed: {
    quadrantData() {
      const result = { 1: [], 2: [], 3: [], 4: [] }
      let list = this.memoList
      if (this.activeQuadrant) {
        list = list.filter(m => m.quadrant === this.activeQuadrant)
      }
      list.forEach(item => {
        const q = item.quadrant || 1
        if (result[q]) {
          result[q].push(item)
        }
      })
      return result
    },
    allTags() {
      const tagSet = new Set()
      this.memoList.forEach(item => {
        if (item.tag) {
          item.tag.split(',').forEach(t => {
            const trimmed = t.trim()
            if (trimmed) tagSet.add(trimmed)
          })
        }
      })
      return [...tagSet]
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.getAllMemo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 500
    },
    getAllMemo() {
      const params = {}
      if (this.keyword.trim()) params.keyword = this.keyword.trim()
      if (this.filterTag) params.tag = this.filterTag
      if (this.filterStatus !== '') params.status = this.filterStatus
      allMemo(params).then(res => {
        if (res.data.status) {
          this.memoList = res.data.memoList || []
        }
      })
    },
    searchMemo: _.debounce(function() {
      this.getAllMemo()
    }, 300),
    clearSearch() {
      this.keyword = ''
      this.getAllMemo()
    },
    filterByQuadrant(q) {
      this.activeQuadrant = this.activeQuadrant === q ? 0 : q
    },
    clearQuadrantFilter() {
      this.activeQuadrant = 0
    },
    toggleStatus(item) {
      if (this.userId != 41) return
      if (this.togglingIds[item.id]) return
      this.togglingIds[item.id] = true
      const newStatus = item.status === 0 ? 1 : 0
      toggleMemoStatus({ id: item.id, status: newStatus }).then(res => {
        if (res.data.status) {
          item.status = newStatus
        }
      }).finally(() => {
        this.togglingIds[item.id] = false
      })
    },
    openAdd() {
      this.editItem = {}
      this.showOperation = 1
    },
    openEdit(item) {
      this.editItem = { ...item }
      this.showOperation = 1
    },
    deleteItem(item) {
      this.pendingDelete = item
      this.popMessage = '确定删除该备忘吗？'
      this.showPopSure = true
      this.$refs.memoPop.open()
    },
    onPopSure() {
      const item = this.pendingDelete
      this.pendingDelete = null
      this.showPopSure = false
      this.$refs.memoPop.close()
      if (!item) return
      deleteMemo({ id: item.id }).then(res => {
        if (res.data.status) {
          this.getAllMemo()
        } else {
          this.popMessage = res.data.message || '删除失败'
          this.showPopSure = false
          this.$refs.memoPop.open()
        }
      })
    },
    onMemoSuccess() {
      this.getAllMemo()
      this.showOperation = 0
    },
    isOverdue(deadline) {
      if (!deadline) return false
      return new Date(deadline) < new Date(new Date().toDateString())
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      const m = d.getMonth() + 1
      const day = d.getDate()
      return m + '/' + day
    },
    closePop() {
      this.showPopSure = false
      this.pendingDelete = null
      this.$refs.memoPop.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>